import { useCallback } from 'react'

import { AcquisitionDataLayerPayload } from '@atoms/acquisitionTracking'

interface SecuredLoanSubmitEvent {
    event: 'form-submit-loans-secured'
}

interface SecuredLoanValidationErrorEvent {
    event: 'secured_validation_errors'
    name_values: string[]
    names: string[]
}

interface AcquisitionFormEvent extends AcquisitionDataLayerPayload {}

interface ArmConversionScoringEvent {
    event: 'arm_conversion' // for TV ad attribution
    step: 'loan_scoring' | 'fcr_loans_scoring'
}

interface ArmConversionProductTableEvent {
    event: 'arm_conversion'
    event_type?: 'pageview' | 'clickout'
    step: 'loan_product_table' | 'fcr_loans_product_table'
}

type ArmConversionEvents =
    | ArmConversionScoringEvent
    | ArmConversionProductTableEvent

type SupportedEventData =
    | SecuredLoanSubmitEvent
    | SecuredLoanValidationErrorEvent
    | AcquisitionFormEvent
    | ArmConversionEvents

const useGoogleTagManager = () => {
    const dataLayer =
        typeof window !== 'undefined' && typeof window.dataLayer !== 'undefined'
            ? window.dataLayer
            : []

    const disable =
        typeof window === 'undefined' || process.env.NODE_ENV === 'development'

    const send = useCallback((eventData: SupportedEventData) => {
        if (dataLayer != null && disable === false) {
            dataLayer.push(eventData)
        } else {
            console.log('[GTM Event]', eventData)
        }
    }, [])

    return send
}

export default useGoogleTagManager
